import React from "react";

export default ({ color = "#2D8EFF" }) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M0.777832 11.4489V14.2222H3.55117L11.4445 6.32887L8.67116 3.55554L0.777832 11.4489ZM13.8978 3.88442C14.1912 3.59109 14.1912 3.12887 13.8978 2.83554L12.1645 1.1022C11.8712 0.808869 11.4089 0.808869 11.1156 1.1022L9.66672 2.55998L12.4401 5.33331L13.8978 3.88442Z" />
    </svg>
);



// WEBPACK FOOTER //
// ./src/icons/edit.js